module.exports = __webpack_public_path__ + "static/media/muji outcome2.8aee8d93.png";